'use strict';

var NavigationHistoryDirective = function NavigationHistoryDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'NavigationHistoryController',
    template: require('../templates/navigation-history.html'),
    scope: {}
  };
};
module.exports = NavigationHistoryDirective;